import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import app from 'flarum/forum/app';

import AltModal from './AltModal';
import { activeAlts, altsLoaded, canCreateAlts, loadAlts, maxAlts, retiredAlts } from '../altsStore';

export default class AltsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    if (!app.session.user) {
      m.route.set(app.route('index'));
      return;
    }

    loadAlts();
  }

  view() {
    if (!altsLoaded()) {
      return (
        <div className="AltsPage">
          <div className="container">
            <LoadingIndicator />
          </div>
        </div>
      );
    }

    const active = activeAlts();
    const retired = retiredAlts();
    const max = maxAlts();

    return (
      <div className="AltsPage">
        <div className="container">
          <h2>{app.translator.trans('nurriemunchers-alts.forum.page.title')}</h2>
          <p className="helpText">{app.translator.trans('nurriemunchers-alts.forum.page.description')}</p>

          {active.length ? (
            <ul className="NurrieAlts-list">{active.map((alt) => this.altItem(alt, false))}</ul>
          ) : (
            <p className="NurrieAlts-empty">{app.translator.trans('nurriemunchers-alts.forum.page.empty')}</p>
          )}

          {retired.length ? (
            <div>
              <h3>{app.translator.trans('nurriemunchers-alts.forum.page.retired_heading')}</h3>
              <ul className="NurrieAlts-list">{retired.map((alt) => this.altItem(alt, true))}</ul>
            </div>
          ) : null}

          <p className="NurrieAlts-remaining">
            {app.translator.trans('nurriemunchers-alts.forum.page.remaining', { count: active.length, max })}
          </p>

          {canCreateAlts() && active.length < max ? (
            <Button className="Button Button--primary" onclick={() => app.modal.show(AltModal)}>
              {app.translator.trans('nurriemunchers-alts.forum.page.create_button')}
            </Button>
          ) : null}
        </div>
      </div>
    );
  }

  altItem(alt, isRetired) {
    return (
      <li className={'NurrieAlts-item' + (isRetired ? ' NurrieAlts-item--retired' : '')} key={alt.id()}>
        <span className="NurrieAlts-item-name">{alt.displayName()}</span>

        <span className="NurrieAlts-item-actions">
          <Button className="Button Button--link" onclick={() => app.modal.show(AltModal, { alt })}>
            {app.translator.trans('nurriemunchers-alts.forum.page.rename_button')}
          </Button>

          <Button className="Button Button--link" onclick={() => this.setRetired(alt, !isRetired)}>
            {isRetired
              ? app.translator.trans('nurriemunchers-alts.forum.page.restore_button')
              : app.translator.trans('nurriemunchers-alts.forum.page.retire_button')}
          </Button>
        </span>
      </li>
    );
  }

  setRetired(alt, retired) {
    app
      .request({
        method: 'PATCH',
        url: app.forum.attribute('apiUrl') + '/alts/' + alt.id(),
        body: { data: { attributes: { isRetired: retired } } },
      })
      .then((payload) => {
        app.store.pushPayload(payload);
        return loadAlts(true);
      });
  }
}
